import { type FallbackProps } from 'react-error-boundary';
import { ButtonPrimary } from '../buttons/button-primary.component';
import './error-fallback.component.scss';

const getErrorMessage = (error: any) => {
  if (error?.response?.data?.result) {
    return error?.response?.data?.result.toString();
  } else {
    return error?.message;
  }
};
export const ErrorFallbackComponent = ({
  resetErrorBoundary,
  error,
}: FallbackProps) => {
  return (
    <div className="error-fallback-component-container">
      <p>An error occurred:</p>
      <pre>{getErrorMessage(error)}</pre>
      <ButtonPrimary onClick={resetErrorBoundary}>Try again</ButtonPrimary>
    </div>
  );
};
